export default {
  registration: {
    header: {
      // title: "",
      // title_esg_data_share: '',
    },
    passcode: {
      section_one: 'Halaman pendaftaran ini khusus untuk perusahaan yang telah meminta Anda untuk menggunakan layanan ini.',
      section_two: 'Silakan masukkan kode sandi untuk melanjutkan ke halaman pendaftaran.',
      section_three: 'Jika tidak menerima kode sandi, silakan hubungi perusahaan yang meminta untuk menggunakan layanan ini.',
      passcode: 'Kode sandi untuk melihat',
      passcode_placeholder: '@:common.form.search_word.placeholder',
      incomplete_input: 'Input Salah.',
      unexpected_error: 'Terjadi kesalahan yang tidak terduga',
    },
    email: {
      section_one: '@:registration.passcode.section_one',
      section_two: 'Silakan masukkan alamat email Anda untuk mendaftar.',
      email: 'Alamat email',
      email_placeholder: 'Isi alamat email',
    },
    sent: {
      section_one: 'Kami telah mengirim email ke alamat yang Anda berikan. ',
      // section_two: "",
      section_three: 'Jika Anda tidak menerima email dalam waktu 30 menit, silakan hubungi ',
      section_four: '.',
    },
    password: {
      // TODO: section_one は日本語だと「アスエネ/アスエネESGの」を「アスエネ関連プロダクトの」に変更する対応が入っており、本言語にはそれが未反映
      section_one: 'Alamat email yang Anda masukkan sudah digunakan untuk akun ASUENE/ASUENE ESG.',
      section_two: 'Silakan masuk dengan kata sandi Anda.',
      password: 'Kata sandi',
      password_placeholder: 'Silakan masukkan kata sandi Anda',
      error_auth: 'Autentikasi gagal. Silakan login lagi',
      error_linking: 'Autentikasi gagal. Masukkan kata sandi lagi',
      // same_domain_modal: {
      //   title: '',
      //   section: '',
      // },
    },
    info: {
      section_one: '@:registration.passcode.section_one',
      section_two: 'Silakan masukkan informasi yang diperlukan untuk menyelesaikan pendaftaran Anda.',
      section_three: 'Silakan masuk dengan akun Anda yang terdaftar setelah mengajukan permohonan dan Anda akan dapat menanggapi survei yang diminta.',
      // buyer_name: "",
      expires_date: 'Tanggal Kedaluwarsa',
      deadline: '@:common.date.answer_expires_date',
    },
    form: {
      invalid_form: '@:settings.messages.invalid_form',
      company_name: 'Nama Perusahaan',
      company_name_placeholder: '@:common.company_name_inc',
      company_scale: '@:settings.company.scale',
      select_placeholder: '@:upload_common.target_select',
      industry_type: '@:settings.company.industry_type',
      first_name: '@:settings.user.first_name',
      last_name_placeholder: 'Yamada',
      last_name: '@:settings.user.last_name',
      first_name_placeholder: 'Taro',
      email: '@:settings.user.email',
      email_placeholder: '@:settings.user.email',
      email_text: 'Alamat email yang Anda masukkan akan ditampilkan',
      // phone: "",
      phone_placeholder: '0000000000',
      locale: 'Pilih Bahasa',
      // section_one: "",
      rule: 'Silakan setujui Syarat',
      rule_link: '/pdf/241112_AsueneESG_Terms_and_Conditions_Supplier.pdf',
      punctuation: ' dan',
      policy: 'Ketentuan serta Kebijakan Privasi',
      policy_link: 'https://asuene.com/en/privacy',
      section_two: 'sebelum melanjutkan.',
      // same_domain_modal: {
      //   title: '',
      //   section: '',
      // },
    },
    thanks: {
      section_one: 'Terima kasih telah mendaftar.',
      section_two: 'Kami telah mengirimkan ID login dan kata sandi Anda ke alamat email yang Anda masukkan.',
      section_three: 'Silakan periksa email Anda dan ikuti petunjuk dalam email untuk login.',
      section_four: 'Jika Anda tidak menerima email dalam waktu 30 menit,',
      // section_five: "",
      // section_six: "",
    },
    expired: {
      section_one: 'URL yang diberikan sudah kedaluwarsa',
      section_two: 'Jika Anda ingin menggunakan layanan ini, silakan hubungi',
      section_three: 'Orang yang bertanggung jawab akan menghubungi Anda.',
    },
    error: {
      section_one: 'URL yang diberikan tidak dapat ditemukan.',
      section_two: 'Kami mohon maaf atas ketidaknyamanan ini, tetapi silakan periksa kembali URL-nya.',
    },
    btn: {
      submit: 'Kirim',
      service_top: 'Atas',
      // login: "",
      register: 'Daftar',
      rating_url: 'https://asuene.com/rating/en',
    },
    buyer: {
      // sharing_company: "",
      // explain_message: "",
    },
  },
}
